const Style = {
    stack: 'space-y-6',
    header: 'flex flex-wrap items-start justify-between gap-3',

    // The uploaded logo had nowhere to show but the upload field itself, so the
    // page you land on after setting one gave no sign it had taken.
    identity: 'flex min-w-0 items-center gap-3',

    // Squared off to match the tile on the projects grid this page opens from —
    // ProjectMark is circular by default, and the initials fallback carries its
    // own rounding, so both need overriding.
    mark: 'h-10 w-10 rounded-md',
    markFallback: 'rounded-md text-xs',

    title: 'text-xl font-semibold text-text-primary',
    description: 'mt-1 text-sm text-text-secondary',
    viewLink: 'text-sm font-medium text-primary-600 hover:underline',
    dangerCard: 'border-error/30',
};

export default Style;
